/**
 * Created by vlad.p on 9/12/2017.
 */

import { Component, EventEmitter, Input, Output, Renderer2, ViewChild } from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { CanadianCurrencyCode } from "../../../../objects/currencyExchange/canadianCurrencyCode";
import { CurrencyItem } from "../../../../objects/currencyExchange/currencyItem";
import { CalculatorType } from "../../../../objects/orders/calculatorType";
import { CustomerCardComponent } from "../../cards/customer-card/customer-card.component";
import { LocationCardComponent } from "../../cards/location-card/location-card.component";
import { ProductsCardComponent } from "../../cards/products-card/products-card.component";
import { ExtraData } from "../../../../objects/extraData/extraData";
import * as ps from "perfect-scrollbar";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { WizardComponent } from "ngx-wizard";

@Component({
    selector: "fill-order-tab",
    templateUrl: "fill-order-tab.component.html",
    moduleId: module.id.toString()
})
export class FillOrderTabComponent {

    @Input()
    public order: Order;

    @Input()
    public canadianCurrencyCodes: CanadianCurrencyCode[];

    @Input()
    public wizard: WizardComponent;

    @Input()
    public extraData: ExtraData;

    @Input()
    public disableChanges: boolean;

    @Input()
    public isPublic: boolean = false;

    @Output()
    public extraDataChange: EventEmitter<ExtraData> = new EventEmitter();

    @ViewChild(CustomerCardComponent)
    public customerCardComponent: CustomerCardComponent;

    @ViewChild(LocationCardComponent)
    public locationCardComponent: LocationCardComponent;

    @ViewChild(ProductsCardComponent)
    public productCardComponent: ProductsCardComponent;

    @Input()
    public isOrderDetails: boolean = false;

    public submitted: boolean = false;

    public isVehicle: boolean = false;

    @Input()
    public sendCustomer:boolean;

    public get isUsService() : boolean {
        return CalculatorHelper.isUsService(this.order);
    }

    constructor(private renderer: Renderer2) {

    }

    public countTotal(): number {
        let total: number = 0;

        if (this.order == null || this.order.OrderItems.length == 0)
            return total;

        if (CalculatorHelper.isSameCurrency(this.order.OrderItems)) {
            for (let orderItem of this.order.OrderItems) {
                if (!isNaN(orderItem.Price))
                    total += orderItem.Price ? +orderItem.Price : 0;
            }

            return total;
        }

        for (let orderItem of this.order.OrderItems) {
            if (orderItem.CanadianCurrencyCode == null || orderItem.CanadianCurrencyCode == null || String.isNullOrEmpty(orderItem.CanadianCurrencyCode.Code))
                continue;

            let exchangeRate: CanadianCurrencyCode = this.canadianCurrencyCodes.find(x => x.Code == orderItem.CanadianCurrencyCode.Code);

            let price: number = +orderItem.Price;

            if (isNaN(price))
                continue;


            if (exchangeRate != null && this.order.CalculatorType != null) {
                price *= exchangeRate.Value; //converted to canadian

                if (this.order.CalculatorType == CalculatorType.UsaImport) {
                    let usdExchangeRate: CanadianCurrencyCode = this.canadianCurrencyCodes.find(x => x.Code == "FXUSDCAD");

                    price = price / usdExchangeRate.Value;
                }
            }

            total += price;
        }

        return total;
    }

    public checkForm(): boolean {
        if (this.disableChanges)
            return true;

        let res = true;

        if (!this.customerCardComponent.checkForm())
            res = false;

        if (!this.locationCardComponent.checkForm())
            res = false;

        if (!this.productCardComponent.checkForm())
            res = false;

        return res;
    }

    public getTotalCurrencyCode(): string {
        if (this.order == null || this.order.OrderItems.length == 0)
            return '';

        if (CalculatorHelper.isSameCurrency(this.order.OrderItems)) {
            return String.isNullOrEmpty(this.order.OrderItems[0].CanadianCurrencyCode.Name) ? '' : this.order.OrderItems[0].CanadianCurrencyCode.Name;
        }

        if (this.order.CalculatorType == null)
            return '';

        if (this.order.CalculatorType == CalculatorType.UsaImport)
            return this.canadianCurrencyCodes.find(x => x.Code == 'FXUSDCAD').Name;

        return this.canadianCurrencyCodes.find(x => x.Code == 'FXCADCAD').Name;
    }

    public goNextTab(): void {
        if (!this.checkForm()) {
            this.submitted = true;
            return;
        }

        const cont = <HTMLElement>document.querySelector(".main-panel");

        if (cont != null) {
            cont.scrollTop = 0;

            ps.update(cont);
        }

        if(!CalculatorHelper.isVehicle(this.order))
            for(let item of this.order.OrderItems)
                item.Year = null


        this.wizard.nextTab()
    }

    public get isDisabled() {
        let res = false;

        if (!this.customerCardComponent.isValid())
            res = true;

        if (!this.locationCardComponent.isValid())
            res = true;

        if (!this.productCardComponent.isValid())
            res = true;

        return res;
    }


    public resetForm(): void {
        this.submitted = false;

        this.customerCardComponent.resetForm();
        this.locationCardComponent.resetForm();
    }

}


// WEBPACK FOOTER //
// ./app/components/calculator/tabs/fill-order-tab/fill-order-tab.component.ts